import * as React from 'react'
import autocomplete from 'autocomplete.js'
import StandardInput from './standard-input'
import { omit, get, set } from 'lodash'
import { withPostcodeAutoComplete } from  '../../common/modules/postcode-auto-complete'
import { withFields } from '../modules/fields'
import './postcode-auto-complete.css'

@withFields
@withPostcodeAutoComplete
export default class extends React.Component<any, any>{
    
    componentDidUpdate(){
        const fields = this.props.fields;
        const postcodeField = this.props.postcodeField;
        const postcode = get(fields, postcodeField)
        
        if(!this.state || postcode != this.state.postcode){
            this.setState({
                ...this.state,
                postcode: postcode,
            })
        }
    }

    componentDidMount(){
        const fields = this.props.fields;
        const config = this.props.config;
        const inputElementId = "#" + this.props.field.replace(".", "-");
        const displayKey = inputElementId;
        const isPostal = this.props.isPostal;
        const field = this.props.field;
        const postcodeField = this.props.postcodeField;
        const unitField = this.props.unitField;
        const streetNumberField = this.props.streetNumberField;
        const streetNameField = this.props.streetNameField;
        const suburbField = this.props.suburbField;
        const stateField = this.props.stateField;
        //const postcode = this.props.postcode;
        const postcode = get(fields, postcodeField)
        const addressNotFoundField = this.props.addressNotFoundField;
        const updateField = this.props.updateField;
        const clearFields = this.props.clearFields;
        const props = this.props;

        if(fields.addressNotFound==false && !fields.streetAddress){
            if((!unitField || get(fields, unitField))
            && get(fields, streetNumberField)
            && get(fields, streetNameField)
            && get(fields, suburbField)
            && get(fields, stateField)){
                updateField('streetAddress', (!unitField? "" : "U"+get(fields,unitField) + " ") + get(fields,streetNumberField) + ' ' + get(fields,streetNameField) + ', ' + get(fields,suburbField) + ', ' + postcode + ', ' + get(fields,stateField))
            }
        }

        autocomplete(inputElementId, { hint: false }, [{
                source:function(query, callback){
                    const axios = props.postcodeAutoComplete.axios
                    const endpoint = props.postcodeAutoComplete.endpoint

                    if(!this.state) return;
                    
                    axios
                    .get(`${endpoint}?postcode=${this.state.postcode}&streetAddress=${query}&hasDeliveryPoint=${unitField?'true':'false'}`, {})
                    .then(response => {
                        const selections = response.data.slice(0, 5);
                        selections.push({ notFound: "Can't find your address? Click here."})
                        callback(selections)
                    })
                }.bind(this),
                delay: 1000,
                templates:{
                    suggestion: function(suggestion){
                        if(suggestion.notFound) return suggestion.notFound;
                        return suggestion.flat_number ? "U" + suggestion.flat_number + " " + suggestion.street_address : suggestion.street_address
                    }
                }
            },
        ]).on('autocomplete:selected', function(event, suggestion, dataset){
            if(suggestion.notFound){
                updateField(field, "");
                if(unitField) updateField(unitField, undefined);
                updateField(streetNumberField, undefined);
                updateField(streetNameField, undefined);
                updateField(suburbField, undefined);
                updateField(stateField, undefined);
                updateField(addressNotFoundField, true);

                if (document.activeElement instanceof HTMLElement){
                    var elem =  document.activeElement;
                    elem.blur()
                    const scrollElem = document.getElementById('address-scroll-point')
                    if(scrollElem && scrollElem.scrollIntoView){
                        scrollElem.scrollIntoView({behavior: "smooth"})
                    }
                }

                return ""
            }else{
                const result = suggestion.flat_number ? "U" + suggestion.flat_number + " " + suggestion.street_address : suggestion.street_address
                if(addressNotFoundField) clearFields([ addressNotFoundField ]);
                updateField(field, result);
                if(unitField) updateField(unitField, suggestion.flat_number);
                updateField(streetNumberField, suggestion.street_number);
                updateField(streetNameField, suggestion.street);
                updateField(suburbField, suggestion.suburb);
                updateField(stateField, suggestion.state);
                updateField(addressNotFoundField, false);

                // Hack: This is required to force the text into the text field.
                // The issue is that pressing enter on an auto complete item updates
                // the field state, but the text of the input element does not update.
                // This might be because of a slight incompatibility between autocomplete.js
                // and React.
                if (document.activeElement instanceof HTMLElement){
                    var elem =  document.activeElement;
                    elem.blur()
                    elem.focus()
                }

                return result;
            }
        })
    }

    clearAddressNotFound(){
        console.log("Focus")
        const addressNotFoundField = this.props.addressNotFoundField;
        const updateField = this.props.updateField;
        updateField(addressNotFoundField, false);
    }

    render(){
        return <StandardInput { ...this.props } blurHack={ true } autocomplete={false} />
    }

}






// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/postcode-auto-complete.tsx